<div class="page-content">
    <div class="contact-bnr">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-4 mb-3">
                    <div
                        class="contact-info style-1 text-white text-center bg-light p-3 h-100 rounded d-flex flex-column align-items-center justify-content-center">
                        <i class="fa-solid fa-location-dot mb-3 text-red fs-2"></i>
                        <h2 class="title fs-4 wow fadeInUp" data-wow-delay="0.1s">Address</h2>
                        <p class="text wow fadeInUp fs-3 mb-0" data-wow-delay="0.2s">
                            78/42, 3rd Main Rd, Gandhi Nagar, Adyar, Chennai, Tamil Nadu 600020
                        </p>
                    </div>
                </div>
                <div class="col-lg-4 mb-3">
                    <div
                        class="contact-info style-1 text-white text-center bg-light p-3 h-100 rounded d-flex flex-column align-items-center justify-content-center">
                        <i class="fa-solid fa-phone mb-3 text-red fs-2"></i>
                        <h2 class="title fs-4 wow fadeInUp" data-wow-delay="0.1s">Call Us</h2>
                        <ul class="list-unstyled mb-0 wow fadeInUp" data-wow-delay="0.2s">
                            <li class="fs-3 text-black">+91 99627 00810</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4 mb-3">
                    <div
                        class="contact-info style-1 text-white text-center bg-light p-3 h-100 rounded d-flex flex-column align-items-center justify-content-center">
                        <i class="fa-solid fa-envelope  mb-3 text-red fs-2"></i>
                        <h2 class="titlefs-4 wow fadeInUp" data-wow-delay="0.1s">Mail</h2>
                        <ul class="list-unstyled mb-0 wow fadeInUp" data-wow-delay="0.2s">
                            <li class="fs-3 text-black">mano&#64;ezhuthupizhai.in</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="content-inner-2 pt-0 overflow-hidden">
        <div class="map-iframe map">
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d67381.90392792471!2d80.251374!3d13.009062!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525d448b2e2fbd%3A0xad80cf358944f9e5!2sEZHUTHUPIZHAI!5e1!3m2!1sen!2sin!4v1756451174526!5m2!1sen!2sin"
                width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
    </div>

</div>